import type { FaireProductEntity } from "../../entity_types/product";

export const p_cad7e7ztdj: FaireProductEntity = {
  token: "p_cad7e7ztdj",
  type: "product",
  name: "GINGHAM PUFFER JACKET",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/db1339aa0d35e68f0c6d46589c94add3a17521280809c519ef68d078e47dfa3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7d67158f5a65463d4f989bc1b14043b944bdbd424a4a6d91952004c12c31ad5.jpeg",
    "https://cdn.faire.com/fastly/e1cb4eae81354b5da5e8b81065acba73574ec96c5eecd73de5111c0de3599bfd.jpeg",
    "https://cdn.faire.com/fastly/03abeb0a94da24c316488b8679528c5b8a8d37bc0943b62e2f99d8d24cc04ce4.jpeg",
    "https://cdn.faire.com/fastly/5d0a04cb1bff5a5a95163332aa0af2a0538f3c8f80b886f00752edccc49ca6ef.jpeg",
    "https://cdn.faire.com/fastly/cc139a717399139aadf8638e3d42884ea9d37dfce009d261677eee22485ceada.jpeg",
  ],
  priceDollars: 354,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 708,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:19.408Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
